
// 로그인 페이지 컴포넌트

function Login(){
        

    return (


        <div className="container">
            <div className="col-md-12">
                <div className="loginBox">
                    <div className="titleH2"><h2>로그인</h2></div>
                    
                    <div className="loginBox">
                        <fieldset style={{width:"380px"}}>
                            
                            <div className="smallTitle">ID</div>
                            <input placeholder="아이디" style={{width:"100%" , fontSize:"13px", marginBottom:"20px", borderTop:"none", borderRight:"none", borderLeft:"none" ,borderBottom:"1px solid #ddd"}}></input>

                            <div className="smallTitle">PASSWORD</div>
                            <input placeholder="비밀번호" style={{width:"100%", fontSize:"13px", marginBottom:"10px",borderTop:"none", borderRight:"none", borderLeft:"none", borderBottom:"1px solid #ddd"}}></input>

                            <div className="RockBox">
                                <div>
                                    <input type="checkbox"></input>
                                    <img src="/img/ico_access.gif"/>
                                </div>
                                
                                <ul>
                                    <li >아이디 찾기</li>
                                    <li><span>/</span></li>
                                    <li >비밀번호 찾기</li>
                                </ul>
                            </div>

                            <ul style={{width:"100%", height:"auto", padding:0, display:"flex", flexWrap:"wrap", justifyContent:"space-evenly" }}>
                                <li style={{marginBottom:"10px", cursor:"pointer"}}><img src="/img/btn_naver_login.gif" /></li>
                                <li style={{cursor:"pointer"}}><img src="/img/btn_facebook_login.gif" /></li>
                                <li style={{cursor:"pointer"}}><img src="/img/btn_google_login.gif" /></li>
                                <li style={{cursor:"pointer"}}><img src="/img/btn_kakao_login.gif" /></li>

                            </ul>

                            <button type="button" class="btn btn-dark" style={{width:"100%", height:"50px", marginTop:"10px"}}>로그인</button>

                            <div className="joinBox" style={{marginTop:"30px", fontSize:"12px" , color:"#888"}}>
                                아직 회원이 아니신가요?<br/>
                                회원가입을 하시면 다양하고 특별한 혜택이 준비되어 있습니다.<br/>


                                <button type="button" class="btn btn-outline-dark" >회원가입</button>
                            </div>

                        </fieldset>


                    </div>
                    

                </div>
            </div>
        
        </div>




    )

}




// Pagination : 이거 밑에 숫자 넘기는 페이지 그거임. 리뷰에다가 찾아보고 넣기.


export default Login


